import { render, staticRenderFns } from "./ReceiptCard.vue?vue&type=template&id=cc9baaec&scoped=true&"
import script from "./ReceiptCard.vue?vue&type=script&lang=js&"
export * from "./ReceiptCard.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptCard.vue?vue&type=style&index=0&id=cc9baaec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9baaec",
  null
  
)

export default component.exports